export default __webpack_public_path__ + "static/bgMobile-610ddc14b736caa2475c2f2b3dc3d5db.jpg";